/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useCallback, useEffect, useRef } from 'react';
import { VideoProviderType } from '../../../../contexts/videoProvider/types';
import IParticipant = VideoProvider.IParticipant;

export function useParticipantsChange(
  videoProvider: VideoProviderType,
  fn: (participants: any[], updatedParticipants?: any[]) => void,
) {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  const callback = useCallback(
    (updatedParticipants?: IParticipant[]) => {
      const participants = videoProvider.getParticipants();
      fnRef.current?.(participants, updatedParticipants);
    },
    [videoProvider],
  );
  useEffect(() => {
    videoProvider.onParticipantConnected(callback);
    videoProvider.onParticipantDisconnected(callback);
    videoProvider.onParticipantUpdated(callback);
    return () => {
      videoProvider.offParticipantConnected(callback);
      videoProvider.offParticipantDisconnected(callback);
      videoProvider.offParticipantUpdated(callback);
    };
  }, [videoProvider, callback]);
  useEffect(() => {
    callback();
  }, []);
}
